const RUTA_GLOBAL = "https://livefit.me/api/";

const HttpService = {
    async registrar(datos, ruta) {
       
        const cuerpo = datos instanceof FormData ? datos : JSON.stringify(datos);
        
        const respuesta = await fetch(RUTA_GLOBAL + ruta, {
            method: "post",
            body: cuerpo,
        });
        return await respuesta.json();
    },

    async obtenerConDatos(datos, ruta) {
        const respuesta = await fetch(RUTA_GLOBAL + ruta, {
            method: "post",
            body: JSON.stringify(datos),
        });
        return await respuesta.json();
    },

    async obtener(ruta) {
        let respuesta = await fetch(RUTA_GLOBAL + ruta)
        return await respuesta.json();
    },

    async eliminar(ruta, datos) {
        const respuesta = await fetch(RUTA_GLOBAL + ruta, {
            method: "post",
            body: JSON.stringify(datos),
        });
        return await respuesta.json();
    }
}

export default HttpService;


// WEBPACK FOOTER //
// ./src/Servicios/HttpService.js